import firebaseApp from "../../firebase/credenciales";
import { getFirestore, collection, getDocs } from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default async function getAllProducts(pagina2, start) {
  const productos = [];
  console.log(pagina2)
  let collectionRef = collection(db, "Almacen_empaque/"+pagina2+"/Productos".replace(/ /g, ""))

  const snapshot = await getDocs(collectionRef);
  snapshot.forEach((doc) => {
    productos.push(doc.data());
  });
  return productos;
}
;